import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Heading, Image, Text } from '@chakra-ui/react';
import { Info, Notification, Section, Tabs } from '@whitbread-eos/atoms';
import { formatAssetsUrl, useSemanticTypography, useStaticHotelInformation } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import HotelRestaurantMenuContent from '../HotelRestaurantMenuContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HotelRestaurant = () => {
  var _data$menus, _data$logoSrc, _data$name, _data$menus2, _data$menus$tabIndex$, _data$menus3, _data$menus4, _data$menus5, _data$menus6, _data$menus7;
  var _useStaticHotelInform = useStaticHotelInformation(),
    data = _useStaticHotelInform.restaurant,
    isLoading = _useStaticHotelInform.isLoading,
    isError = _useStaticHotelInform.isError,
    error = _useStaticHotelInform.error;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    tabIndex = _useState2[0],
    setTabIndex = _useState2[1];
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var getTypographyProps = useSemanticTypography();
  var headingTypographyProps = getTypographyProps(headingLegacyTypography, headingSemanticTypography);
  var isSemanticHeadingTypography = 'textStyle' in headingTypographyProps;
  if (isLoading) {
    return _jsx(Text, {
      children: t('searchresults.list.hotel.loading')
    });
  }
  if (isError) {
    return _jsx(Text, {
      children: error.message
    });
  }
  if (!(data !== null && data !== void 0 && (_data$menus = data.menus) !== null && _data$menus !== void 0 && _data$menus.length)) {
    return null;
  }
  return _jsx(Section, {
    dataTestId: "hdp_restaurant",
    children: _jsxs(Box, {
      title: t('restaurant.title'),
      children: [_jsx(Heading, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        as: "h3",
        "data-testid": "hotel-restaurant-section"
      }, isSemanticHeadingTypography ? {
        size: 'none'
      } : {
        size: 'md'
      }), headingLayoutStyles), headingTypographyProps), {}, {
        children: t('restaurant.title')
      })), _jsx(Box, _objectSpread(_objectSpread({}, imageContainerStyles), {}, {
        children: (data === null || data === void 0 ? void 0 : data.logoSrc) !== '' && (data === null || data === void 0 ? void 0 : data.logoSrc) !== null && _jsx(Image, {
          src: formatAssetsUrl((_data$logoSrc = data === null || data === void 0 ? void 0 : data.logoSrc) !== null && _data$logoSrc !== void 0 ? _data$logoSrc : ''),
          alt: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : '',
          objectFit: "contain",
          maxHeight: {
            base: '40px',
            sm: '65px'
          },
          "data-testid": "hotel-restaurant-logo"
        })
      })), !!(data !== null && data !== void 0 && (_data$menus2 = data.menus) !== null && _data$menus2 !== void 0 && (_data$menus2 = _data$menus2[tabIndex]) !== null && _data$menus2 !== void 0 && (_data$menus2 = _data$menus2.disclaimer) !== null && _data$menus2 !== void 0 && _data$menus2.length) && _jsx(Notification, _objectSpread(_objectSpread({
        title: (_data$menus$tabIndex$ = data === null || data === void 0 || (_data$menus3 = data.menus) === null || _data$menus3 === void 0 || (_data$menus3 = _data$menus3[tabIndex]) === null || _data$menus3 === void 0 ? void 0 : _data$menus3.disclaimer) !== null && _data$menus$tabIndex$ !== void 0 ? _data$menus$tabIndex$ : '',
        status: "info",
        variant: "infoGrey",
        svg: _jsx(Info, {}),
        description: "",
        prefixDataTestId: "hdp_restaurants"
      }, notificationLayoutStyles), getTypographyProps(notificationLegacyTypography, notificationSemanticTypography))), (data === null || data === void 0 || (_data$menus4 = data.menus) === null || _data$menus4 === void 0 ? void 0 : _data$menus4.length) === 1 ? _jsx(HotelRestaurantMenuContent, {
        menu: data === null || data === void 0 || (_data$menus5 = data.menus) === null || _data$menus5 === void 0 ? void 0 : _data$menus5[0]
      }) : _jsx(Tabs, {
        onChange: tabIndex => setTabIndex(tabIndex),
        pt: 2.5,
        sx: _objectSpread({}, tabsStyles()),
        styles: {
          tab: {
            minW: {
              mobile: "calc(100% / ".concat(data === null || data === void 0 || (_data$menus6 = data.menus) === null || _data$menus6 === void 0 ? void 0 : _data$menus6.length, ")"),
              sm: '6rem'
            },
            maxWidth: {
              xs: '12rem',
              mobile: '7rem'
            }
          },
          tabList: {
            w: {
              xl: "calc(100% / 2 - 1.5rem + 1.5rem / 2)",
              lg: "calc(100% / 2 - 1.5rem + 1.5rem / 2)",
              md: '39.813rem',
              mobile: 'full'
            }
          }
        },
        variant: "tabsGroup",
        prefixDataTestId: "restaurantConfiguration",
        labelStyles: {
          selected: {
            textStyle: 'body-m-emphasis'
          },
          unselected: {
            textStyle: 'body-m-regular'
          }
        },
        options: data === null || data === void 0 || (_data$menus7 = data.menus) === null || _data$menus7 === void 0 ? void 0 : _data$menus7.map((menu, index) => {
          var _menu$name;
          return {
            index,
            label: (_menu$name = menu === null || menu === void 0 ? void 0 : menu.name) !== null && _menu$name !== void 0 ? _menu$name : '',
            content: _jsx(HotelRestaurantMenuContent, {
              menu: menu,
              isTabPanel: true
            })
          };
        })
      })]
    })
  });
};
var tabsStyles = () => ({
  '.chakra-tabs__tablist': {
    w: {
      xl: "calc(100% / 2 - 1.5rem + 1.5rem / 2)",
      lg: "calc(100% / 2 - 1.5rem + 1.5rem / 2)",
      md: '39.813rem',
      mobile: 'full'
    }
  },
  '.chakra-tabs__tab': {
    minWidth: '6rem',
    maxWidth: {
      xs: '12rem',
      mobile: '7rem'
    }
  }
});
var imageContainerStyles = {
  mb: 5,
  width: '100%',
  height: 'auto'
};
var notificationLayoutStyles = {
  maxWidth: {
    base: 'full',
    md: '70%'
  },
  borderColor: '#80CACE'
};
var notificationLegacyTypography = {
  fontWeight: 'bold',
  fontSize: 'sm',
  lineHeight: 2
};
var notificationSemanticTypography = {
  textStyle: 'body-s-emphasis'
};
var headingLegacyTypography = {
  fontSize: {
    base: 'xl',
    md: '2xl'
  },
  fontWeight: 'semibold',
  lineHeight: {
    base: '3',
    md: '4'
  }
};
var headingSemanticTypography = {
  textStyle: {
    base: 'heading-s',
    md: 'heading-m'
  }
};
var headingLayoutStyles = {
  mb: '4',
  mt: '3xl'
};
export { HotelRestaurant };